export function canTrulyHover() {
  if (!globalThis.document) {
    return false;
  }
  if (globalThis.navigator.userAgent.includes('jsdom')) {
    return true;
  }
  if (window.matchMedia) {
    const atHoverQuery = window.matchMedia('(hover: hover),(-moz-hover: hover),(-ms-hover: hover),(-webkit-hover: hover)');
    if (atHoverQuery.matches) {
      return true;
    }
  }
  if (window.PointerEvent || window.MSPointerEvent) {
    return !((window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints) > 0);
  }
  if (window.matchMedia) {
    const touchEnabledQuery = window.matchMedia('(touch-enabled),(-moz-touch-enabled),(-ms-touch-enabled),(-webkit-touch-enabled)');
    if (touchEnabledQuery.matches) {
      return false;
    }
  }
  if ('ontouchstart' in window) {
    return false;
  }
  return true;
}